import { TriangleAlert } from "lucide-react";

import style from "./PCRSMidMonthNotice.module.css";

// The patient was registered on PCRS in the first half of the month, so a review
// dated before the 1st may not be reimbursed.
//
// Deliberately does NOT promise that the review will be held as a draft: whether
// that happens is the BE's call (`cdm.midmonth.hold.enable`) and isn't knowable
// here, before anything is submitted. If the BE does hold it, HeldDraftNotice —
// which is driven by the actual held draft — explains it afterwards.
export const PCRSMidMonthNotice = () => {
  return (
    <div className={style.notice} role="status">
      <TriangleAlert size={20} className={style.icon} />
      <p className={style.text}>
        This patient was registered on PCRS in the first half of the month. A CDM
        review dated before the start of next month may not be paid, as PCRS can
        only verify the registration from the 1st.
      </p>
    </div>
  );
};
